import en from "./en.json"
import fr from "./fr.json"
import nl from "./nl.json"

export const messages = {
    en,
    fr,
    nl
}
